const isFile = (url, mimes) => {
  if (!url) return false

  const path = url.startsWith('http') ? (new URL(url)).pathname : url
  const file = path && path.match(/\.\w{3,4}$/)

  if (mimes && file) {
    const types = [].concat(mimes)
    return types.some(type => path.endsWith(`.${type}`))
  } else {
    return file == true
  }
}

export default isFile
